import { render } from "./BookingFormRoom.vue?vue&type=template&id=b92b7bd8"
import script from "./BookingFormRoom.vue?vue&type=script&lang=js"
export * from "./BookingFormRoom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__